import {
  Component, ChangeDetectorRef, Renderer2, Inject,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DOCUMENT } from '@angular/common';

import { ListManagerComponent } from '../list-manager/list-manager.component';
import { FitmentsListService } from './fitments-list.service';


@Component({
  moduleId: module.id,
  selector: 'fitment-list-manager',
  templateUrl: '../list-manager/list-manager.component.html',
  styleUrls: ['../list-manager/list-manager.component.scss'],
})
export class FitmentListManagerComponent extends ListManagerComponent {

  constructor(
    protected fb: UntypedFormBuilder,
    protected listManagerService: FitmentsListService,
    protected ref: ChangeDetectorRef,
    @Inject(DOCUMENT) protected document: any,
    protected renderer: Renderer2,
  ) {
    super(fb, listManagerService, ref, document, renderer);
  }

}
